export const apiRest = process.env.REACT_APP_API_REST;

export const MAPS_API_KEY = "AIzaSyArOoqzUgxtt2rxD8v6MLPbXFMp4YPUIz4";

export const orderState = {
  canceled: "Cancelado",
  pending: "Pendiente",
  inPreparation: "En preparación",
  prepared: "Preparado",
  delivered: "Entregado",
};
